import { Injectable } from "@angular/core";

export type AppTheme =
  | 'theme-light'
  | 'theme-dark'
  | 'theme-sapphire'
  | 'theme-sand'
  | 'theme-gunmetal'
  | 'theme-indigo'
  | 'theme-mortal-kombat';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly storageKey = 'pb_theme';

  private readonly themes: AppTheme[] = [
    'theme-light',    
    'theme-dark',
    'theme-sapphire',
    'theme-sand',    
    'theme-gunmetal',
    'theme-indigo',
    'theme-mortal-kombat',
  ];

  private readonly defaultTheme: AppTheme = 'theme-dark';

  /** Read theme from localStorage (validated) */
  getCurrentTheme(): AppTheme {
    const saved = localStorage.getItem(this.storageKey);

    if (saved && this.themes.includes(saved as AppTheme)) {
      return saved as AppTheme;
    }

    return this.defaultTheme;
  }

  /** Apply a theme and persist it */
  apply(theme: AppTheme): void {
    const root = document.documentElement; // <html>
    this.themes.forEach(t => root.classList.remove(t));
    root.classList.add(theme);
    localStorage.setItem(this.storageKey, theme);
  }

  /** Call once at app startup to restore persisted theme */
  init(): void {
    this.apply(this.getCurrentTheme());
  }
}

